import React, { useEffect, useState } from 'react';

import styles from './DogCardDogshow.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import { general } from '../../../../../../general';

function DogCardDogshow(props: DogCardDogshowProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/dogshows",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData(res.data);
            if (props.onDataLoaded != undefined) {
                props.onDataLoaded(res.data);
            }
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed]);

    return (
        <div className={styles.dogshowcard}>
            <Card
                title={props.title || "Use Overview"}
                children={<div>
                    <hr/>
                    <table className={styles.showstable}>
                        <thead>
                            <tr>
                                <th>{t("dog.statistics.areas.exterior.dogshows.card.table.headers.date")}</th>
                                <th>{t("dog.statistics.areas.exterior.dogshows.card.table.headers.place")}</th>
                                <th>{t("dog.statistics.areas.exterior.dogshows.card.table.headers.judge")}</th>
                                <th>{t("dog.statistics.areas.exterior.dogshows.card.table.headers.title")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((row: any, index: number) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <span style={{
                                                width: "26px",
                                                display: "block",
                                                height: "20px",
                                                float: "left"
                                            }}>
                                                {row.LENKE_KRITIKK != null ? 
                                                    <a href={"https://www.dogweb.no" + row.LENKE_KRITIKK} target="_blank" rel="noreferrer">
                                                        <i className="fas fa-external-link-alt"></i>
                                                    </a>
                                                : null}
                                            </span>
                                            {general.dateToString(new Date(row.DATO))}
                                        </td>
                                        <td>{row.STED}</td>
                                        <td>{row.DOMMER}</td>
                                        <td>{row.TITTEL}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>}
            ></Card>
        </div>
    );
}

class DogCardDogshowProps {
    title?: string;
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardDogshow;
